<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div style="padding: 15px; margin: 5px;width: -webkit-fill-available;">
            <div class="main-heading">
                <h1>Request Training Data</h1>
            </div>

            <!-- <div style="margin-bottom: 20px;">
                <a routerLink="/errordashboard" class="link-card">Back</a>
            </div> -->

            <div class="card">
                <p-table [value]="trainingData" [tableStyle]="{'min-width': '60rem'}" [paginator]="true" [rows]="10"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10, 20, 50]" [loading]="loading">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Client name</th>
                            <!-- <th>client_username</th> -->
                            <th>Email ID</th>
                            <!-- <th>ip</th> -->
                            <!-- <th>request_made</th> -->
                            <th>Requested date</th>
                            <th>Pending since</th>
                            <!-- <th pSortableColumn="Revenue">Revenue <p-sortIcon field="Revenue"></p-sortIcon></th> -->
                            <th>Closed? (Y/N)</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td>{{ rowData['client_organization'] }}</td>
                            <!-- <td>{{ rowData['client_username'] }}</td> -->
                            <td>{{ rowData['client_email'] }}</td>
                            <!-- <td>{{ rowData['ip'] }}</td> -->
                            <!-- <td>{{ rowData['request_made'] }}</td> -->
                            <td>{{ rowData['request_time'] }}</td>
                            <td>{{ rowData['pending_since']}}</td>
                            <!-- <td><button class="btn btn-primary">Close</button></td> -->
                            <td>
                                <ng-container *ngIf="!rowData['closed']; else closedText">
                                    <button class="btn btn-primary"
                                        (click)="closeRequest(rowData['client_email'], rowData['client_organization'], rowData['client_username'], rowData['ip'], rowData['request_made'] )">Close</button>
                                </ng-container>
                                <ng-template #closedText>
                                    CLOSED
                                </ng-template>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft">
                        <p-button type="button" icon="pi pi-plus" styleClass="p-button-text"></p-button>
                    </ng-template>
                    <ng-template pTemplate="paginatorright">
                        <p-button type="button" icon="pi pi-cloud" styleClass="p-button-text"></p-button>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </ng-container>
</div>